import { DirectionalHint } from "@fluentui/react";
import { CoachmarkLocaleItem } from "../Locales/Coachmarks/Locale_CoachmarkItem";

export class CoachmarkInfo {
	constructor(public LocalStorageKey: string, public Target: string, public LocaleItem: CoachmarkLocaleItem, public DirectionalHint: DirectionalHint) { }
}